import { render } from "./StoreConfigurationContactInformations.vue?vue&type=template&id=87570a18"
import script from "./StoreConfigurationContactInformations.vue?vue&type=script&lang=js"
export * from "./StoreConfigurationContactInformations.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./StoreConfigurationContactInformations.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_828d00b8%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fstore%2Fdetails%2FStoreConfigurationContactInformations.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__